import { initialiseInstanceComponents } from '../../shared/instanceComponentInitialiser';
import { AttributeEnums } from '../../shared/utilities/enums/attributeEnums';
import { HelperUtils } from '../../shared/utilities/helperUtils';
import { ReadMore } from './readMoreController';

export function initialiseReadMore() {
    initialiseInstanceComponents<ReadMore>(ReadMore, HelperUtils.addDataAttributeTags(AttributeEnums.ReadMore.ReadMoreToggle), readMoreFactory);
}

function readMoreFactory(currenElement: Element): void {
    let readMoreToggleId = currenElement.getAttribute(AttributeEnums.ReadMore.ReadMoreToggle);
    let readMoreContentElement = document.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReadMore.ReadMoreContent, readMoreToggleId));
    let newReadMore = new ReadMore(currenElement, readMoreContentElement);
    (<any>window)['rm' + currenElement.getAttribute(AttributeEnums.ReadMore.ReadMoreToggle) + 'ReadMore'] = newReadMore;
}